import gql from 'graphql-tag';
// import { getFYList } from '../../../util/shared/tmc-global';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const fields = {
  _id: '',
  town: '',
  direction: '',
  streetName: '',
  streetType: '',
  count: '',
};

export const TaxStreets = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    selectedItems: [],
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
  },
  actions: {
    async loadTaxStreetsRecords({ commit, dispatch }, { baseCrudKey, criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query taxStreets($criteria: taxStreetsCriteriaType) {
            taxStreets(criteria: $criteria) {
              ${fieldsToGqlString(fields)},
            }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxStreets } = results.data;
          commit('base/crud/setItems', [baseCrudKey, taxStreets], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting List.', { root: true });
      }
    },
    async upsertTaxStreets({ dispatch, rootGetters, commit }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upserttaxStreets($item: taxStreetsInputType!)  {
            upserttaxStreets(upsert: $item) {
              ${fieldsToGqlString(fields)},
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const taxData = rootGetters['base/crud/items'](baseCrudKey);
        const newTaxUnit = results.data.upserttaxStreets;
        const newList = mergeByIdNewAtTop(taxData || [], newTaxUnit);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the List', { root: true });
      }
    },
    async deleteTaxStreet({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deletetaxStreet ($id: ID!)  {
            deletetaxStreet(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deletetaxStreet._id;
        const taxData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = taxData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the List', { root: true });
      }
    },
    async taxStreetReUpdateTheCollection({ commit, dispatch }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
            taxStreetReUpdateTheCollection { statusCode },
          }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          return results.data.taxStreetReUpdateTheCollection;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting accessor roll the tax street collection.', { root: true });
      }
      return {};
    },
  },
};

export default TaxStreets;
